export enum LoginStep {
    CheckBlocked,
    Credentials,
    Evaluate2FARequirement,
    Configure2FA,
    Check2FARequired,
    Enter2FA,
    CheckPasswordResetRequired,
    ResetPassword,
    FinalizeLogin,
    Complete,
}

export interface LoginContextData {
    BrowserFingerprint: string | undefined;
    LoginMessage: string | undefined;
    NewPassword: string | undefined;
    Password: string | undefined;
    TwoFACode: string | undefined;
    UserID: number | undefined;
    UserName: string | undefined;
    ValidUserNamePassword: boolean | undefined;
}

export interface ITwoFAPayload {
    BrowserFingerprint: string;
    Password: string;
    UserAgent: string;
    UserID: number;
    UserName: string;
}
